import React, { useEffect, useContext } from "react";
import { TbFaceIdError } from "react-icons/tb";
import { useTable } from "react-table";
import { Spinner } from "react-bootstrap";
import { IoSearch } from "react-icons/io5";
import { WidthContext } from "../contexts/WidthContext";
import { ThemeContext } from "../App";
import { useThemeManager } from "../Hooks/ThemeManager";

const IndeterminateCheckbox = React.forwardRef(({ indeterminate, ...rest }, ref) => {
  const defaultRef = React.useRef();
  const resolvedRef = ref || defaultRef;

  React.useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);

  return <input type="checkbox" ref={resolvedRef} {...rest} />;
});

const TableWrapper = ({
  table,
  className = "",
  loading = true,
  height = true,
  clear = false,
  customH = "70vh",
  RubikF = "#fff",
  header = true,
  onlyOne = false,
  tdStyle = "",
  responsive = true,
  documents = false,
}) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = table;
  const { currentWidth } = useContext(WidthContext);
  const { themeColors } = useThemeManager();

  return (
    <div className={height ? "table-responsive" : ""} style={height ? { height: customH, maxHeight: customH } : {}}>
      <div
        style={{
          border: "1px solid #edf3ff",
          borderTopLeftRadius: "15px",
          borderTopRightRadius: "15px",
          overflow: "hidden",
        }}
      >
        <table
          className={`table table-hover ${className} ${currentWidth < 650 && responsive ? "agregarResponsive" : ""}
          ${currentWidth < 850 && responsive ? "scroll-b" : ""}`}
          {...getTableProps()}
        >
          {header && (
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr style={{ borderWidth: "0px 0", textAlign: "center" }} {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      className="table-header"
                      {...column.getHeaderProps({
                        style: {
                          minWidth: column.minWidth,
                          width: column.width,
                          textAlign: "center",
                          color: 'var(--secondary-color)',
                        },
                      })}
                    >
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
          )}
          <tbody {...getTableBodyProps()}>
            {documents ? (
              <tr>
                <td colSpan="100%">
                  <div
                    className="my-5 flex-row justify-content-center"
                    style={{ margin: "5px auto", display: "block" }}
                  >
                    <div className="d-flex justify-content-center">
                      <div className="spinner blue"></div>
                    </div>
                    <div
                      className="d-flex justify-content-center color-secondary"
                      style={{ fontSize: 20, fontWeight: "bolder" }}
                    >
                      Existen documentos que están siendo procesados...
                    </div>
                  </div>
                </td>
              </tr>
            ) : loading ? (
              <tr>
                <td colSpan="100%" className="d-fklex justify-content-center">
                  <div className="my-3 d-flex justify-content-center">
                    <div className="spinner blue"></div>
                  </div>
                </td>
              </tr>
            ) : (
              <>
                {rows.length === 0 && (
                  <tr>
                    <td colSpan="100%">
                      <div
                        className="my-5 flex-row justify-content-center"
                        style={{ margin: "5px auto", display: "block" }}
                      >
                        <div className="d-flex justify-content-center">
                          {onlyOne ? (
                            <IoSearch className="color-secondary" style={{ fontSize: 86, marginBottom: "25px" }} />
                          ) : (
                            <TbFaceIdError
                              className="color-secondary" style={{ fontSize: 86, marginBottom: "25px" }}
                            />
                          )}
                        </div>
                        <div
                          className="d-flex justify-content-center color-secondary"
                          style={{ fontSize: 18, fontWeight: "bolder" }}
                        >
                          {onlyOne ? "Escribe para buscar" : "No hay resultados para mostrar"}
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </>
            )}
            {React.Children.toArray(
              rows.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()} style={row.depth === 1 ? {} : {}}>
                    {row.cells.map((cell) => {
                      let value = cell.render("Cell");
                      return (
                        <td
                          {...cell.getCellProps({
                            style: {
                              minWidth: cell.column.minWidth,
                              width: cell.column.width,
                              textAlign: "center",
                              verticalAlign: "middle",
                              color: 'var(--secondary-color)',
                            },
                          })}
                          className={`${tdStyle}`}
                        >
                          {currentWidth < 650 ? (
                            <div className="tdFlex">
                              {/* Solo renderiza el header si no es la columna ID o si tiene contenido */}
                              {cell.column.id !== "id" && (
                                <div className="item color-secondary">
                                  {cell.column.render("Header")}:
                                </div>
                              )}
                              <div className="conten color-secondary">
                                {value}
                              </div>
                            </div>
                          ) : (
                            value
                          )}
                        </td>
                      );
                    })}
                  </tr>
                );
              }),
            )}
          </tbody>
        </table>
      </div>
      <div className="table-footer"></div>
    </div>
  );
};

export default TableWrapper;
